import { CardNumberElement } from "@stripe/react-stripe-js";

export const TrCardNumberElement = (props) => {
    const { onChange } = props

    const stripeCardElementStyle = "border border-grey h-12 w-full";

    const cardStyle = {
        style: {
            base: {
                color: "#000",
                fontFamily: "Roboto, sans-serif",
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::plaeholder": {
                    color: "#606060",
                },
            },
            invalid: {
                color: "fa755a",
                iconColor: "#fa755a"
            }
        }
    };

    return (
        <tr>
            <td>
                <div className="stripe-card">
                    <CardNumberElement 
                        className={stripeCardElementStyle}
                        onChange={ onChange }
                        options={ cardStyle }
                    />
                </div>
            </td>
        </tr>
    );
}